import { useContext } from "react";
import { AuthCustomContext } from "../context/AuthContext";

const useUser = () => {
  const arg = useContext(AuthCustomContext);
  return { ...arg };
};

export default useUser;
